import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { ApiStateData, MakerSelectors, Section } from 'types';

type Roles = Array<string>;
type I18nKeys = Record<string, string>;

interface Configs {
  roles: Roles;
  i18nKeys: I18nKeys;
  dropdownUrls: {
    postalCodes: string;
    taxRegime: string;
  };
}

interface Data {
  sections: Array<Section>;
  configs: Configs;
}

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getVisiblePagesAndSeparators: (d: ApiStateData<Data>) => Array<Section>;
  getVisiblePages: (d: ApiStateData<Data>) => Array<Section>;
  getHiddenPages: (d: ApiStateData<Data>) => Array<Section>;
  getGetSectionRoute: (d: ApiStateData<Data>) => (pageName: string) => string | undefined;
  getRoles: (d: ApiStateData<Data>) => Roles | undefined;
  getI18nKeys: (d: ApiStateData<Data>) => I18nKeys | undefined;
  getDropdownUrl: (d: ApiStateData<Data>) => (key: keyof Configs['dropdownUrls']) => string;
}

export const configFetch = createApiSlice<Data, undefined, ExtraSelectors>({
  name: 'configFetch',
  *tryGenerator() {
    const { KODS_APP_ENV } = process.env;

    const response: Data = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({
        path: `/cms/front-config/indexCartaPorte${KODS_APP_ENV === 'omega' ? 'v2' : ''}`,
      }),
    });

    return response;
  },
  extraSelectors: {
    getVisiblePagesAndSeparators: (data) =>
      data?.sections?.filter(({ showInMenu, type }) => type === 'separator' || showInMenu) || [],
    getVisiblePages: (data) =>
      data?.sections?.filter(({ showInMenu, type }) => type !== 'separator' && showInMenu) || [],
    getHiddenPages: (data) =>
      data?.sections.filter(({ showInMenu, type }) => type !== 'separator' && !showInMenu) || [],
    getGetSectionRoute: (data) => (pageName) =>
      data?.sections.find(({ name }) => pageName === name)?.route,
    getRoles: (data) => data?.configs.roles,
    getI18nKeys: (data) => data?.configs?.i18nKeys,
    getDropdownUrl: (data) => (key) => data?.configs?.dropdownUrls[key] || '<mocked Url>',
  },
});
